import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = {
  id: number;
};
export type FinishReservation = {
  data: Reservation;
};

export const useFinishReservation = createMutation<
  FinishReservation,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/finish`,
      method: 'POST',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        console.error('yoyo', err);
        throw new Error(err.response.data.errors.join(', '));
      }),
});
